<template>
  <div class="eval-config-panel">
    <div class="panel-header">
      <h3>评测模型设置</h3>
      <el-button size="small" :loading="saving" type="primary" @click="saveConfig">保存</el-button>
    </div>
    <p class="hint">此模型仅用于评测(网页端) harness 重跑推荐管线打分，与 iOS 客户端推荐模型相互独立、互不影响。</p>

    <el-form v-loading="loading" label-width="90px" class="config-form">
      <el-form-item label="粗推模型">
        <el-select
          v-model="form.eval_coarse_model"
          filterable
          allow-create
          default-first-option
          placeholder="选择或输入模型名，如 deepseek-v4-flash"
          style="width: 320px"
        >
          <el-option v-for="m in modelOptions" :key="m.model_id" :label="`${m.name} (${m.model_id})`" :value="m.model_id" />
        </el-select>
      </el-form-item>
      <el-form-item label="精排模型">
        <el-select
          v-model="form.eval_rerank_model"
          filterable
          allow-create
          default-first-option
          placeholder="选择或输入模型名，如 deepseek-v4-flash"
          style="width: 320px"
        >
          <el-option v-for="m in modelOptions" :key="m.model_id" :label="`${m.name} (${m.model_id})`" :value="m.model_id" />
        </el-select>
      </el-form-item>
    </el-form>
  </div>
</template>

<script setup>
import { ref, reactive, onMounted } from 'vue';
import axios from 'axios';
import { ElMessage } from 'element-plus';

const loading = ref(false);
const saving = ref(false);
const modelOptions = ref([]);

const form = reactive({
  eval_coarse_model: '',
  eval_rerank_model: '',
});

const loadModelOptions = async () => {
  try {
    const resp = await axios.get('/api/models');
    if (resp.data.code === 1) {
      modelOptions.value = resp.data.data || [];
    }
  } catch (err) {
    console.error('加载 AI 模型候选列表失败:', err);
  }
};

const loadConfig = async () => {
  loading.value = true;
  try {
    const resp = await axios.get('/api/eval/config');
    if (resp.data.code === 1) {
      form.eval_coarse_model = resp.data.data.eval_coarse_model;
      form.eval_rerank_model = resp.data.data.eval_rerank_model;
    } else {
      ElMessage.error(resp.data.msg || '加载评测模型配置失败');
    }
  } catch (err) {
    console.error('加载评测模型配置失败:', err);
    ElMessage.error(err.response?.data?.msg || '加载评测模型配置失败');
  } finally {
    loading.value = false;
  }
};

const saveConfig = async () => {
  if (!form.eval_coarse_model || !form.eval_rerank_model) {
    ElMessage.warning('粗推模型和精排模型不能为空');
    return;
  }
  saving.value = true;
  try {
    const resp = await axios.put('/api/eval/config', {
      eval_coarse_model: form.eval_coarse_model,
      eval_rerank_model: form.eval_rerank_model,
    });
    if (resp.data.code === 1) {
      ElMessage.success('评测模型配置已保存');
      form.eval_coarse_model = resp.data.data.eval_coarse_model;
      form.eval_rerank_model = resp.data.data.eval_rerank_model;
    } else {
      ElMessage.error(resp.data.msg || '保存评测模型配置失败');
    }
  } catch (err) {
    console.error('保存评测模型配置失败:', err);
    ElMessage.error(err.response?.data?.msg || '保存评测模型配置失败');
  } finally {
    saving.value = false;
  }
};

onMounted(() => {
  loadModelOptions();
  loadConfig();
});
</script>

<style scoped>
.eval-config-panel {
  margin-bottom: 20px;
  padding: 16px;
  background: #f5f7fa;
  border-radius: 4px;
}

.eval-config-panel .panel-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 4px;
}

.eval-config-panel .panel-header h3 {
  margin: 0;
}

.eval-config-panel .hint {
  margin: 4px 0 16px;
  font-size: 12px;
  color: #909399;
}

.config-form {
  margin-bottom: -18px;
}
</style>
